export const LOCAL_STORAGE_KEYS = {
  BROWSER_LANGUAGE: 'BROWSER_LANGUAGE',
  USER_LANGUAGE: 'USER_LANGUAGE',
};
